import React from 'react';

import checkboxFilled from '../images/checkbox_filled.svg';
import checkboxEmpty from '../images/checkbox_empty.svg';

export default function Checkbox({ checked }) {
  return <img src={checked ? checkboxFilled : checkboxEmpty} alt="Checkbox" />;
}
